import { render } from "./WebsiteFooter.vue?vue&type=template&id=634d98bd&scoped=true"
import script from "./WebsiteFooter.vue?vue&type=script&lang=js"
export * from "./WebsiteFooter.vue?vue&type=script&lang=js"

import "./WebsiteFooter.vue?vue&type=style&index=0&id=634d98bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634d98bd"]])

export default __exports__